import React from 'react';
import { CircularProgress, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

const Root = styled(Grid)(({ theme }) => ({
	width: '110px',
	height: '110px',
	borderRadius: '10px',
	position: 'relative'
}));

const Image = styled('img')(({ theme }) => ({
	width: 'inherit',
	height: 'inherit',
	borderRadius: 'inherit',
	objectFit: 'cover',
	objectPosition: 'center'
}));

const Overlay = styled(Grid, {
	shouldForwardProp: (prop) => prop !== 'uploading'
})(({ theme, uploading }) => ({
	width: 'inherit',
	height: 'inherit',
	borderRadius: 'inherit',
	position: 'absolute',
	top: 0,
	left: 0,
	backgroundColor: uploading ? '#00000077' : '#00000000',
	opacity: uploading ? 1 : 0,
	transition: 'background-color 0.3s, opacity 0.3s',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center'
}));

const Loader = styled(CircularProgress)(({ theme }) => ({
	width: '35px !important',
	height: '35px !important',
	color: theme.palette.text.contrast
}));

function ImageUploadPreview({ src, uploading, progress }) {
	const loaderVariant = !progress ? 'indeterminate' : 'determinate';
	return (
		<Root>
			<Image src={src} />

			<Overlay uploading={uploading}>
				{<Loader variant={loaderVariant} value={progress} />}
			</Overlay>
		</Root>
	);
}

export default ImageUploadPreview;
